import { lazy } from "react";

export const LandingSecondScreenAsync = lazy(() => import("./LandingSecondScreen"));
